import * as tslib_1 from "tslib";
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { List } from 'material-ui/List';
import { IconButton, FontIcon } from 'material-ui';
import { cyan500, grey500 } from 'material-ui/styles/colors';
import Divider from 'material-ui/Divider';
import TaskNoteItem from './TaskNoteItem';
import { Events } from 'src/services/Events';
import { TASK_NOTE_CLOSING_PROMPT } from 'src/constants/messages';
var styles = {
    textContainer: {
        display: 'flex',
        padding: '1rem'
    },
    icon: {
        backgroundColor: 'transparent',
        alignSelf: 'center',
        height: 'auto'
    },
    textarea: {
        flex: 1,
        padding: '.75rem 2rem',
        height: '80px',
        resize: 'none',
        overflowX: 'hidden',
        border: '1px solid #e0e0e0',
        borderRadius: '5px 0px 0px 5px',
        overflowY: 'auto',
        backgroundColor: '#fafafa'
    }
};
var TaskNotes = /** @class */ (function (_super) {
    tslib_1.__extends(TaskNotes, _super);
    function TaskNotes(props) {
        var _this = _super.call(this, props) || this;
        _this.handleTaskDialogClosed = function (args) {
            if (_this.state.text) {
                args.confirmed = window.confirm(TASK_NOTE_CLOSING_PROMPT);
            }
            else {
                args.confirmed = true;
            }
        };
        _this.handleTextChange = function (e) {
            _this.setState({ text: e.target.value });
        };
        _this.handleClick = function (e) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var text, userId;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        text = this.state.text;
                        userId = this.props.userStore.userId;
                        if (!text) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.props.task.addNote(userId, text)];
                    case 1:
                        _a.sent();
                        this.setState({ text: '' });
                        _a.label = 2;
                    case 2:
                        this.contentRef.current.scrollTo(0, this.contentRef.current.offsetTop);
                        return [2 /*return*/];
                }
            });
        }); };
        _this.insertNoteTemplate = function (e) {
            e.preventDefault();
            var canInsert = !_this.state.text || window.confirm('Biztosan beilleszti a megjegyzés sablont?');
            if (canInsert) {
                _this.setState({ text: _this.props.task.noteTemplate });
            }
        };
        _this.state = {
            text: ''
        };
        _this.contentRef = React.createRef();
        return _this;
    }
    TaskNotes.prototype.componentWillMount = function () {
        Events.taskDialogClosed.subscribe(this.handleTaskDialogClosed);
    };
    TaskNotes.prototype.componentWillUnmount = function () {
        Events.taskDialogClosed.unsubscribe(this.handleTaskDialogClosed);
    };
    TaskNotes.prototype.render = function () {
        var task = this.props.task;
        var items = task.notes.map(function (i) { return (React.createElement("div", { key: i.id },
            React.createElement(TaskNoteItem, { task: task, note: i }),
            React.createElement(Divider, null))); });
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { ref: this.contentRef, className: "task-tab-content", style: { maxHeight: '425px' } },
                React.createElement(List, null, items)),
            React.createElement("div", { style: styles.textContainer },
                React.createElement(IconButton, { style: tslib_1.__assign({}, styles.icon, { position: 'absolute', alignSelf: 'start' }), onClick: this.insertNoteTemplate, tooltip: "Megjegyz\u00E9s sablon beilleszt\u00E9se", tooltipPosition: "bottom-right" },
                    React.createElement(FontIcon, { color: grey500, className: "material-icons icon-sm" }, "content_paste")),
                React.createElement("textarea", { spellCheck: true, lang: "hu", style: styles.textarea, placeholder: "Megjegyz\u00E9s...", onChange: this.handleTextChange, value: this.state.text }),
                React.createElement(IconButton, { style: styles.icon, tooltip: "Megjegyz\u00E9s k\u00FCld\u00E9se", onClick: this.handleClick },
                    React.createElement(FontIcon, { color: cyan500, className: "material-icons" }, "send")))));
    };
    TaskNotes = tslib_1.__decorate([
        inject('userStore'),
        observer
    ], TaskNotes);
    return TaskNotes;
}(React.Component));
export default TaskNotes;



//////////////////
// WEBPACK FOOTER
// ./src/pages/tasks/TaskNotes.tsx
// module id = 746
// module chunks = 0